import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActiveSessionGuard } from './shared/guards/active-session-guard/active-session.guard';
import { AuthCallbackComponent } from './login/auth/auth-callback.component';
import { LoginErrorPageComponent } from './login/login-error-page/login-error-page.component';
import { AuthenticatedLayoutComponent } from './authenticated-layout/authenticated-layout.component';
import { UnauthenticatedLayoutComponent } from './unauthenticated-layout/unauthenticated-layout.component';

const appRoutes: Routes = [ 
  { path: 'auth-callback', component: AuthCallbackComponent },
  { path: 'login-error-page', component: LoginErrorPageComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', canLoad: [], data: {}, canActivate: [], loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  {
    path: '', component: UnauthenticatedLayoutComponent, children: [
      { path: 'user-agreement', canLoad: [], data: {}, canActivate: [], loadChildren: () => import('./user-agreement/user-agreement.module').then(m => m.UserAgreementModule) },
  ]},
  {
    path: '', component: AuthenticatedLayoutComponent, children: [
      { path: 'ebook', canLoad: [], data: {}, canActivate: [ActiveSessionGuard], loadChildren: () => import('./e-book/ebook.module').then(m => m.EBookModule) },
      { path: 'faq', canLoad: [], data: {}, canActivate: [ActiveSessionGuard], loadChildren: () => import('./shared/components/faq/faq.module').then(m => m.FAQModule) },
      { path: 'copyrights-and-licenses', canLoad: [], data: {}, canActivate: [ActiveSessionGuard], loadChildren: () => import('./shared/components/copyrights-and-licenses/copyrights-and-licenses.module').then(m => m.CopyrightsAndLicensesModule) },
      { path: 'privacy-policy', canLoad: [], data: {}, canActivate: [ActiveSessionGuard], loadChildren: () => import('./shared/components/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule) },
      { path: 'simulations', canLoad: [], data: {}, canActivate: [], loadChildren: () => import('./simulations/simulations.module').then(m => m.SimulationsModule) }
  ]},
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { } 
